import CryptoJS from 'crypto-js';

const key = CryptoJS.enc.Hex.parse('2b7e151628aed2a6abf7158809cf4f3c');
const iv = CryptoJS.enc.Hex.parse('3ad77bb40d7a3660a89ecaf32466ef97');

export const decrypt = (encryptedData) => {
  const decryptedData = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(encryptedData) },
    key,
    { iv: iv }
  );
  
  const decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
  return decryptedText;
};